export default {
  notFoundTitle: 'We could not find this page',
  notFoundLead: 'The page you are looking for doesn’t exist or is no longer available.',
  notFoundCta: 'Back to the homepage',

  legalBack: 'Back',

  // Imprint & privacy notice are German legal texts – kept in German.
};
